import { render, staticRenderFns } from "./uploadOrderFile.vue?vue&type=template&id=12961550&scoped=true&"
import script from "./uploadOrderFile.vue?vue&type=script&lang=js&"
export * from "./uploadOrderFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadOrderFile.vue?vue&type=style&index=0&id=12961550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12961550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12961550')) {
      api.createRecord('12961550', component.options)
    } else {
      api.reload('12961550', component.options)
    }
    module.hot.accept("./uploadOrderFile.vue?vue&type=template&id=12961550&scoped=true&", function () {
      api.rerender('12961550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/components/uploadOrderFile.vue"
export default component.exports